import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["master", "channel"]

  sync() {
    this.channelTargets.forEach((channel) => {
      channel.disabled = !this.masterTarget.checked
      if (channel.disabled) channel.checked = false
    })
  }
}
